import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'

import './thirdParty'
import '@/assets/css/index.scss'
import 'bootstrap/dist/js/bootstrap'
import './utils/filter'
import './utils/const'
import langI18n from './i18n/lang'

import VueMeta from 'vue-meta'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import { AuthService } from '@/services/auth.service'
import VueMask from 'v-mask'

const VueInputMask = require('vue-inputmask').default

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueMeta)

Vue.use(VueCookies)
Vue.$cookies.config(60 * 15, '/', process.env.VUE_APP_COOKIE_DOMAIN, true, 'lax')

Vue.use(VueInputMask)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: AuthService.getLocalStorage('locale') || 'vie',
  messages: langI18n
})

Vue.use(VueMask)

new Vue({
  name: 'Root',
  router,
  store,
  i18n,
  render: h => h(AppLayout)
}).$mount('#app')
